import React from 'react';
import Logo from '../Logo/Logo';

const Footer = () => {
    return (
      <div className="containerFooter">
        <Logo />
        <p>© 2020 Kasa. All rights reserved</p>
      </div>
    );
};

export default Footer;